import { createRoute, Outlet, redirect } from "@tanstack/solid-router";
import { isAdminCapable } from "@malla/shared";
import { appRoute } from "./route";
import { sessionActor } from "@/lib/session-machine";
import { readAccountsStateSync } from "@/lib/accounts";
import { resolveActiveAccountView } from "@/lib/active-account";
import { readTabAccountId } from "@/lib/tab-account";

export const adminRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/admin",
  beforeLoad: () => {
    // Per-tab gating: resolve THIS tab's active account from sessionStorage pin,
    // NOT the global session machine.
    const tabPin = readTabAccountId();
    const view = resolveActiveAccountView(
      readAccountsStateSync(),
      tabPin,
      sessionActor.getSnapshot().context.session,
    );

    // Back-office (#18): allow any admin-capable role (super_admin/admin/support/
    // read_only).
    if (!isAdminCapable(view.role)) {
      // oxlint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: "/profile" });
    }
  },
  component: () => <Outlet />,
});
